document.addEventListener('click', (e) => {
  const toggleBtn = e.target.closest('[data-offers-toggle]');
  if (toggleBtn) {
    const container = toggleBtn.closest('.section-product-offers');
    if (!container) return;
    const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
    const offers = container.querySelectorAll('.section-product-offer--hidden');
    if (isExpanded) {
      offers.forEach((offer) => {
        offer.classList.remove('is-visible');
        offer.addEventListener('transitionend', () => {
          offer.style.display = '';
        }, { once: true });
      });
    } else {
      offers.forEach((offer) => {
        offer.style.display = 'flex';
        requestAnimationFrame(() => {
          requestAnimationFrame(() => offer.classList.add('is-visible'));
        });
      });
    }
    toggleBtn.setAttribute('aria-expanded', String(!isExpanded));
    toggleBtn.querySelector('[data-offers-label]').textContent = isExpanded ? 'Show more' : 'Show less';
    return;
  }

  const minusBtn = e.target.closest('[data-quantity-minus]');
  const plusBtn = e.target.closest('[data-quantity-plus]');
  const btn = minusBtn || plusBtn;
  if (!btn) return;

  const form = btn.closest('form');
  if (!form) return;

  const input = form.querySelector('input[type="number"][name="quantity"]');
  if (!input) return;

  const current = parseInt(input.value, 10) || 1;
  const min = parseInt(input.min, 10) || 1;
  const max = parseInt(input.max, 10) || 99;

  if (minusBtn) {
    input.value = Math.max(min, current - 1);
  } else {
    input.value = Math.min(max, current + 1);
  }

  input.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.querySelector('[data-sticky-atc]');
  const buyWrap = document.querySelector('.section-product-buy-wrap');

  if (stickyBar && buyWrap) {
    if (window.NumourReleaseControls?.hideInlinePdpBuyControls) {
      buyWrap.hidden = true;
      stickyBar.classList.add('is-visible');
      stickyBar.setAttribute('aria-hidden', 'false');
    } else {
      let buyWrapVisible = false;
      let footerVisible = false;

      const update = () => {
        const shouldShowStickyBar = !buyWrapVisible && !footerVisible;
        stickyBar.classList.toggle('is-visible', shouldShowStickyBar);
        stickyBar.setAttribute('aria-hidden', String(!shouldShowStickyBar));
      };

      const buyObserver = new IntersectionObserver(
        ([entry]) => { buyWrapVisible = entry.isIntersecting; update(); },
        { threshold: 0 }
      );
      buyObserver.observe(buyWrap);

      const footer = document.querySelector('footer.footer');
      if (footer) {
        const footerObserver = new IntersectionObserver(
          ([entry]) => { footerVisible = entry.isIntersecting; update(); },
          { threshold: 0 }
        );
        footerObserver.observe(footer);
      }
    }
  }

  const stickyBtn = document.querySelector('[data-sticky-atc-btn]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', async () => {
      if (stickyBtn.disabled) return;

      const variantInput = document.querySelector('form[data-product-form] input[name="id"]');
      const variantId = variantInput ? variantInput.value : null;
      if (!variantId) return;

      const quantityInput = document.querySelector('form[data-product-form] input[name="quantity"]');
      const quantity = Math.min(quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1, 10);

      const textEl = stickyBtn.querySelector('[data-sticky-btn-text]');
      const originalText = textEl ? textEl.textContent.trim() : null;

      stickyBtn.disabled = true;
      if (textEl) textEl.textContent = 'Adding...';

      try {
        const cartDrawerEl = document.querySelector('cart-drawer');
        const sectionId = cartDrawerEl?.dataset.sectionId;
        const payload = { id: parseInt(variantId, 10), quantity };
        if (sectionId) {
          payload.sections = sectionId;
          payload.sections_url = window.location.pathname;
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload),
        });

        if (!response.ok) throw new Error('Cart add failed');
        const data = await response.json();

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, data);
        }
        if (typeof handleFloCartBtn === 'function') {
          handleFloCartBtn();
        }

        if (textEl) textEl.textContent = 'Added!';
        setTimeout(() => {
          if (textEl) textEl.textContent = originalText;
          stickyBtn.disabled = false;
        }, 2000);
      } catch (e) {
        console.error('[sticky-atc]', e);
        if (textEl) textEl.textContent = originalText;
        stickyBtn.disabled = false;
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const productSection = document.querySelector('[data-product-section]');
  if (!productSection) return;

  const productId = productSection.dataset.productId;
  const variantSelector = productSection.querySelector('variant-selector');
  if (!variantSelector) return;
  const priceEl = document.querySelector('[data-product-price]');
  const comparePriceEl = document.querySelector('[data-product-compare-price]');
  const discountEl = document.querySelector('[data-product-discount]');

  const updatePrice = (variant) => {
    if (!priceEl) return;
    priceEl.textContent = variant.price_formatted;
    if (comparePriceEl) {
      if (variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = variant.compare_at_price_formatted;
        comparePriceEl.classList.remove('hidden');
      } else {
        comparePriceEl.classList.add('hidden');
      }
    }
    if (discountEl) {
      if (variant.compare_at_price > variant.price) {
        const discount = Math.round(
          ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
        );
        discountEl.textContent = `${discount}% off`;
        discountEl.classList.remove('hidden');
      } else {
        discountEl.classList.add('hidden');
      }
    }
  };

  const updateURL = (variant) => {
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  subscribe(PUB_SUB_EVENTS.variantChange, (data) => {
    if (data.productId !== productId) return;
    if (!data.variant) {
      if (discountEl) discountEl.classList.add('hidden');
      return;
    }
    updatePrice(data.variant);
    updateURL(data.variant);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const galleryEl = document.querySelector('[data-pdp-gallery]');
  if (!galleryEl || typeof EmblaCarousel === 'undefined') return;

  const viewport = galleryEl.querySelector('.section-product-gallery-main');
  if (!viewport) return;

  const embla = EmblaCarousel(viewport, { loop: true });
  // Product-alternatives can replace a related product's full gallery without
  // a page reload. Keep the active carousel accessible for that handoff.
  galleryEl._numourEmbla = embla;

  const thumbs = Array.from(galleryEl.querySelectorAll('[data-thumb]'));
  const progressFill = galleryEl.querySelector('[data-gallery-progress-fill]');
  const progressTotal = parseInt(galleryEl.querySelector('[data-gallery-progress]')?.dataset.total || '0', 10);
  const prevBtn = galleryEl.querySelector('[data-gallery-prev]');
  const nextBtn = galleryEl.querySelector('[data-gallery-next]');
  const thumbsTrack = galleryEl.querySelector('.section-product-gallery-thumbs');

  const scrollThumbIntoView = (index) => {
    const thumb = thumbs[index];
    if (!thumb || !thumbsTrack) return;
    const trackRect = thumbsTrack.getBoundingClientRect();
    const thumbRect = thumb.getBoundingClientRect();
    if (thumbRect.left < trackRect.left) {
      thumbsTrack.scrollBy({ left: thumbRect.left - trackRect.left, behavior: 'smooth' });
    } else if (thumbRect.right > trackRect.right) {
      thumbsTrack.scrollBy({ left: thumbRect.right - trackRect.right, behavior: 'smooth' });
    }
  };

  const updateSelected = (index) => {
thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === index);
      thumb.setAttribute('aria-pressed', String(i === index));
    });
    scrollThumbIntoView(index);
    if (progressFill && progressTotal > 0) {
      progressFill.style.width = ((index + 1) / progressTotal * 100) + '%';
    }
  };

  embla.on('select', () => updateSelected(embla.selectedScrollSnap()));
  updateSelected(0);

  prevBtn?.addEventListener('click', () => embla.scrollPrev());
  nextBtn?.addEventListener('click', () => embla.scrollNext());

const getVisibleThumbRange = () => {
    if (!thumbsTrack) return { first: -1, last: -1 };
    const trackRect = thumbsTrack.getBoundingClientRect();
    let first = -1;
    let last = -1;
    thumbs.forEach((thumb, i) => {
      const rect = thumb.getBoundingClientRect();
      if (rect.left >= trackRect.left - 1 && rect.right <= trackRect.right + 1) {
        if (first === -1) first = i;
        last = i;
      }
    });
    return { first, last };
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const idx = parseInt(thumb.dataset.thumb, 10);
      embla.scrollTo(idx);

      const { first, last } = getVisibleThumbRange();

      if (idx === last && last < thumbs.length - 1) {
        thumbsTrack.scrollBy({ left: thumbsTrack.clientWidth, behavior: 'smooth' });
      } else if (idx === first && first > 0) {
        thumbsTrack.scrollBy({ left: -thumbsTrack.clientWidth, behavior: 'smooth' });
      }
    });
  });

  galleryEl.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') embla.scrollPrev();
    if (e.key === 'ArrowRight') embla.scrollNext();
  });

  document.addEventListener('variant:change', (e) => {
    const { featured_media } = e.detail?.variant || {};
    if (!featured_media) return;
    const slides = Array.from(viewport.querySelectorAll('[data-slide]'));
    const idx = slides.findIndex((s) => s.dataset.mediaId === String(featured_media.id));
    if (idx !== -1) embla.scrollTo(idx);
  });
});

(function () {
  var wrapper = document.querySelector('.atc-offer-cycle[data-atc-cycle]');
  if (!wrapper) return;

  var slot = wrapper.querySelector('.atc-offer-slot');
  var texts = wrapper.dataset.atcCycle.split('|||');
  var idx = 0;
  var busy = false;

  wrapper.style.height = (slot.offsetHeight || 13) + 'px';
  wrapper.style.minWidth = slot.scrollWidth + 'px';

  wrapper._cycleTimer = setInterval(function () {
    if (busy) return;
    busy = true;

    var next = (idx + 1) % texts.length;

    slot.style.transition = 'transform 0.2s ease';
    slot.style.transform = 'translateY(-100%)';

    setTimeout(function () {
      slot.textContent = texts[next];
      slot.style.transition = 'none';
      slot.style.transform = 'translateY(100%)';

      var w = slot.scrollWidth;
      if (w > parseInt(wrapper.style.minWidth || '0', 10)) wrapper.style.minWidth = w + 'px';

      slot.getBoundingClientRect();
      slot.style.transition = 'transform 0.2s ease';
      slot.style.transform = 'translateY(0)';

      idx = next;
      busy = false;
    }, 200);
  }, 3000);

  document.addEventListener('turbo:before-cache', function () {
    clearInterval(wrapper._cycleTimer);
  }, { once: true });
})();
